import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionResultForm from '../../../components/forms/CompetitionResultForm';
import { useCompetitionResultById, useUpdateCompetitionResult } from '../../../hooks/useCompetitionResultApi';
import { useNavigate, useParams } from 'react-router-dom';

const CompetitionResultEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useCompetitionResultById(id!);
  const updateCompetitionResult = useUpdateCompetitionResult();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Results', href: '/admin/competitionresults' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateCompetitionResult.mutateAsync({ id: id!, data });
      navigate('/admin/competitionresults');
    } catch (error) {
      console.error('Error updating CompetitionResult:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionresults"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.CompetitionResult.Edit'
    >
      {entityData ? (
        <CompetitionResultForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/competitionresults')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default CompetitionResultEdit;
